import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Auth0SessionService } from '../../services/auth/identity/auth0-session.service';
import { environment } from '../../../environments/environment';

@Component({
  standalone: true,
  imports: [],
  template: `<main class="sign-in"><section>
    <img src="/assets/images/logos/shine.svg" alt="Shine" (error)="hideLogo($event)">
    <h1>Sign in to Shine</h1>
    <p>Use your Shine account to open the Backoffice.</p>
    @if (failed) { <p role="alert">{{ errorMessage }}</p> }
    @if (staffSso) { <button type="button" (click)="login('staff')">Sign in with Microsoft</button> }
    <button type="button" (click)="login()">Sign in with a Shine account</button>
    <small>{{ environmentLabel }}</small>
  </section></main>`,
  styles: [`.sign-in { min-height:100vh;display:grid;place-items:center;background:#f5f7fa;padding:24px; }
    section { max-width:440px;background:white;padding:48px;border-radius:16px;box-shadow:0 12px 40px #12213a12; }
    img { max-width:130px; } h1 { font-size:28px; } p { color:#536171;line-height:1.6; }
    button { display:block;width:100%;margin-top:12px;background:#275dda;color:white;border:0;border-radius:8px;padding:14px 24px;font:inherit;cursor:pointer; }
    small { display:block;margin-top:24px;color:#667085; }`],
})
export class Auth0LoginComponent {
  private readonly sessions = inject(Auth0SessionService);
  private readonly route = inject(ActivatedRoute);
  readonly failed = Boolean(this.route.snapshot.queryParamMap.get('error'));
  readonly errorMessage = this.route.snapshot.queryParamMap.get('error') === 'access_denied'
    ? 'This account does not have Shine access. Ask a Shine administrator to link your account and assign permissions.'
    : 'We couldn’t complete sign-in. Please try again.';
  readonly staffSso = Boolean(environment.auth0StaffConnection);
  readonly environmentLabel = ({
    beta: 'Beta environment', staging: 'Staging environment', production: 'Production environment',
  } as Record<string, string>)[environment.environment] || 'Local environment';
  login(mode?: 'staff'): void { this.sessions.login(this.route.snapshot.queryParamMap.get('returnPath') || '/', mode); }
  hideLogo(event: Event): void { (event.target as HTMLImageElement).hidden = true; }
}
